var InputType;
(function (InputType) {
    InputType["Text"] = "text";
    InputType["Number"] = "number";
    InputType["Email"] = "email";
    InputType["Decimal"] = "decimal";
    InputType["PositiveDecimal"] = "positive-decimal";
})(InputType || (InputType = {}));
export default InputType;
